// This file was generated by "make codegen/icons". DO NOT EDIT.
import { createSvgIcon } from "@mui/material";
/* GENERATED */
const AwsLambdaFunctionsIcon = createSvgIcon(
  <svg width={40} height={40} fill="none" viewBox="0 0 40 40">
    <path fill="url(#aws-lambda-functions_svga)" d="M40 0H0v40h40z" />
    <path
      fill="#fff"
      fillRule="evenodd"
      d="M14.39 33H8.27l6.76-14.43 3.07 6.44zm1.08-15.8a.5.5 0 0 0-.44-.28.5.5 0 0 0-.44.28L7.05 33.28a.5.5 0 0 0 .03.49q.14.22.41.23h7.2a.5.5 0 0 0 .45-.29l3.95-8.48a.5.5 0 0 0 0-.44zM32.02 33h-5.88l-9.47-20.71a.5.5 0 0 0-.45-.29h-3.85V7h7.55l9.43 20.71a.5.5 0 0 0 .44.29h2.23zm.49-6h-2.4L20.68 6.29a.5.5 0 0 0-.44-.29h-8.36a.5.5 0 0 0-.49.5v6q0 .2.14.35t.35.15h4.03l9.47 20.71a.5.5 0 0 0 .44.29h6.69a.5.5 0 0 0 .49-.5v-6a.5.5 0 0 0-.5-.5"
      clipRule="evenodd"
    />
    <defs>
      <linearGradient
        id="aws-lambda-functions_svga"
        x1={0}
        x2={40.99}
        y1={0}
        y2={38.96}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#9147FF" />
        <stop offset={1} stopColor="#4C35E8" />
      </linearGradient>
    </defs>
  </svg>,
  "AwsLambdaFunctions",
);
export default AwsLambdaFunctionsIcon;
